import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  ContentTemplate,
  Grid,
  KeyValue,
  Link,
  Progress,
  SectionHeader,
  TitleHeader,
} from 'web-library';

import RouteKey from '../../../routes/key';
import { stringToLongDateAndShortTimeWithSecond } from '../../../utils/DateUtils';
import { useGetSCAcknowledgement } from '../../../api/candidate/special-consideration/@candidate/queries-services/queries';
import { useWOGAA } from '../../../hooks/wogaa';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const { specialConsideration, coordinatorApplicationSummary } = RouteKey[
  'special-consideration'
].child;

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  link: {
     ...typographyTheme(theme, 'h3'),
  },
  apiButton: {
    marginBottom: theme.spacing(8),
  },
}));

const ApplicationSubmitted = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const { uuid: applicationUuid } = useParams<{ uuid: string }>();

  const { data: scAcknowledgementData } = useGetSCAcknowledgement(applicationUuid);
 // Wogaa tracking end for SC application by coordinator //
  const { transactionEnd } = useWOGAA('myexamsseab-6463');
  // Wogaa tracking end for SC amendment by coordinator //
  const { transactionEnd: transactionEndAmendment } = useWOGAA('myexamsseab-6464');
  transactionEnd(applicationUuid);
  transactionEndAmendment(applicationUuid);

  if (!scAcknowledgementData) {
    return <Progress color="secondary" />;
  }

  return (
    <>
      <TitleHeader
        title={t(
          'specialConsideration->>ApplyForSpecialConsideration.SubmittedSpecialConsideration'
        )}
        state="success"
      />
      <ContentTemplate>
        <Grid container direction="row" alignItems="flex-start">
          <SectionHeader
            title={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationDetails')}
          />
          <Link
            className={classes.link}
            id="link-full-summary"
            onClick={() => history.replace(`${coordinatorApplicationSummary.route}`)}
          >
            {t('specialConsideration->>ApplyForSpecialConsideration.ViewFullSummary')}
          </Link>
        </Grid>
        <KeyValue
          id="application-date-time"
          keyText={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationDateTime')}
          valueText={stringToLongDateAndShortTimeWithSecond(
            scAcknowledgementData.applicationDateTime
          )}
        />
        <KeyValue
          id="application-id"
          keyText={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationId')}
          valueText={scAcknowledgementData.applicationId}
        />
        <Button
          className={classes.apiButton}
          id="button-back-to-application"
          type="submit"
          onClick={() => history.replace(`/${specialConsideration.route}`)}
        >
          {t('specialConsideration->>ApplyForSpecialConsideration.BackToApplication')}
        </Button>
      </ContentTemplate>
    </>
  );
};

export default ApplicationSubmitted;
